import ManageModal from './manage-modal.container'
export default ManageModal